import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  small: {
    padding: 0,
    zIndex: 25,
    position: 'relative',
    height: '100vh',
    width: 80,
    minWidth: 80,
    maxWidth: 80,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[9],
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: '0.2s all ease-in-out',
  },
  large: {
    padding: 0,
    zIndex: 25,
    position: 'relative',
    height: '100vh',
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[9],
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: '0.2s all ease-in-out',
  },
  logo: {
    padding: 0,
    width: '100%',
    height: 80,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: (useStylesParams) =>
      useStylesParams.large ? 'space-between' : 'center',
    marginTop: 15,
    marginBottom: 15,
    marginLeft: (useStylesParams) => (useStylesParams.large ? 15 : 0),
    marginRight: (useStylesParams) => (useStylesParams.large ? 15 : 0),
  },
  scroll: {
    width: '100%',
    overflowY: 'auto',
    height: '100%',
    flexGrow: 1,
    paddingLeft: 15,
    paddingRight: 15,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      height: 5,
      width: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.primary.main,
    },
  },
  footer: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 15,

    display: 'flex',
    flexDirection: 'column',
  },
  linkUser: {
    padding: 0,
    width: '100%',
    paddingTop: 0,
    marginTop: 0,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
  },
  lastUpdate: {
    marginTop: 18,
    marginBottom: 10,
    fontSize: 11,
    color: theme.palette.metrics[5],
  },
  tooltipHeader: {
    marginTop: 10,
    marginBottom: 18,
    color: theme.palette.metrics[6],
  },
}))

export default useStyles
